export default "__VITE_PUBLIC_ASSET__307e5d7d__"